import React from 'react';
import { EXAMPLE_CLIENT_PHOTO_MODAL_NAME } from 'src/app/shared/components/modals/exampleClientPhoto/const';
import { INSTALL_MOBILE_APPLICATION_MODAL_NAME } from 'src/app/shared/components/modals/installMobileApplication/const';
import { useModal } from 'src/shared/modalProvider';
import { useIsEmbedded } from 'src/shared/mediaQueries';

export const useChangeClientPhoto = () => {
  const { openModal } = useModal();
  const isEmbedded = useIsEmbedded();

  return [
    React.useCallback(() => {
      if (!isEmbedded) {
        return openModal(INSTALL_MOBILE_APPLICATION_MODAL_NAME);
      }
      openModal(EXAMPLE_CLIENT_PHOTO_MODAL_NAME);
    }, [openModal, isEmbedded]),
  ];
};
